import OnMountIsLoadedMixin from '@/mixins/on-mount-is-loaded';
import { ITextUserMessageContent } from '@/models/bot-models';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class UserTextMessage extends OnMountIsLoadedMixin {
    @Prop({ default: () => ({}) }) public content!: ITextUserMessageContent;
}
